<template>
  <v-dialog v-model="dialog" max-width="470" content-class="rounded-lg" :persistent="loading">
    <v-card class="">
      <v-card-title class="d-flex gap-2 justify-space-between align-center">
        Tem certeza que deseja cancelar a verificação de beneficio a meia entrada?
      </v-card-title>
      <v-card-text>
        <p class="mb-0">A solicitação de benefício será cancelada e não poderá ser recuperada.</p>
        <p>Você poderá enviar uma nova solicitação de benefício.</p>
        <v-alert v-if="error" type="error" class="mb-0">
          {{ error }}
        </v-alert>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="dialog = false" :disabled="loading"> Voltar </v-btn>
        <v-spacer />
        <v-btn color="error" @click="cancel" depressed :loading="loading"> Confirmar cancelamento </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import ACCOUNT from "@/services/account";

export default {
  name: "ConcessionCancelModal",
  props: {
    concession: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapGetters("auth", ["user"]),
  },
  data() {
    return {
      dialog: false,
      checked: false,
      loading: false,
      error: null,

    };
  },
  mounted() {
    this.$parent.$on("cancelRequest", () => {
      this.dialog = true;
    });
  },
  methods: {
    async cancel() {
      try {
        this.loading = true;
        this.error = null;
        await ACCOUNT.concession.revoke();
        this.close();
        this.$emit("refresh");
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>
